import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-foreground mb-8">Terms of Service</h1>

          <div className="prose prose-sm max-w-none text-foreground space-y-6">
            <p className="text-muted-foreground">
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing or using JobAspirant, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not use our service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">2. Service Description</h2>
              <p className="text-muted-foreground">
                JobAspirant provides resume analysis, job matching, skill gap analysis, and personalized learning roadmaps. Our service is provided "as is" and we do not guarantee specific outcomes or job placements.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">3. User Accounts</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>You are responsible for maintaining the confidentiality of your account credentials</li>
                <li>You must provide accurate information when creating an account</li>
                <li>You must be at least 18 years old to use our service</li>
                <li>One account per user; sharing accounts is prohibited</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">4. Payment Terms</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li><strong>Free Tier:</strong> We may or may not offer a free tier at our discretion. Free tier availability, features, and limits are subject to change without notice</li>
                <li><strong>Paid Tier:</strong> Pay-as-you-go pricing for analyses</li>
                <li>Payments are processed securely through payment gateways</li>
                <li>All fees are non-refundable unless required by law or at our discretion</li>
                <li>We reserve the right to change pricing</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">5. User Content</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>You retain ownership of your resume content</li>
                <li>You grant us permission to process your resume for analysis purposes</li>
                <li>You are responsible for ensuring your resume content does not violate any third-party rights</li>
                <li>We do not claim ownership of your resume files or content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">6. Prohibited Uses</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Using the service for any illegal or unauthorized purpose</li>
                <li>Attempting to reverse-engineer or extract our AI models or algorithms</li>
                <li>Uploading malicious files, viruses, or harmful code</li>
                <li>Automated scraping or bulk analysis without permission</li>
                <li>Impersonating others or providing false information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">7. Disclaimers</h2>
              <p className="text-muted-foreground">
                Our AI analysis is provided for informational purposes only. We do not guarantee job placements, interview callbacks, or specific career outcomes. Analysis results are based on AI interpretation and should be used as guidance, not definitive advice.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">8. Limitation of Liability</h2>
              <p className="text-muted-foreground">
                To the maximum extent permitted by law, Qubitly Ventures LLP and JobAspirant shall not be liable for any indirect, incidental, or consequential damages arising from your use of the service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">9. Termination</h2>
              <p className="text-muted-foreground">
                We reserve the right to suspend or terminate your account if you violate these terms. You may delete your account at any time from Account Settings.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">10. Changes to Terms</h2>
              <p className="text-muted-foreground">
                We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">11. Contact Information</h2>
              <p className="text-muted-foreground">
                For questions about these terms, contact us at: <a href="mailto:contact@qubitlyventures.com" className="text-primary hover:underline">contact@qubitlyventures.com</a>
              </p>
              <p className="text-muted-foreground mt-2">
                <strong>Parent Company:</strong> Qubitly Ventures LLP, Delhi NCR, India
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;